<template>
  <footer class="page-foot bg-cape-cod context-dark novi-background bg-cover">
    <!-- 主要内容区域 -->
    <div class="section-40 section-md-75">
      <div class="container">
        <div class="row row-fix justify-content-sm-center justify-content-md-start">
          <div class="col-sm-9 col-md-11 col-xl-12">
            <div class="row row-50">
              <!-- 公司信息 -->
              <div class="col-md-6 col-lg-10 col-xl-3">
                <div class="inset-xl-right-20" style="max-width: 510px;">
                  <a class="brand brand-inverse" href="/">
                    <!-- <img src="images/logo-light-282x68.png" alt="" width="282" height="68"/> -->
                  </a>
                  <p class="text-dusty-gray">合肥联静数字科技有限公司</p>
                  <div class="link-block">
                  </div>
                </div>
              </div>
              
              <!-- 联系方式 -->
              <div class="col-md-6 col-lg-4 col-xl-3">
                <h6 class="text-small-16 text-uppercase footer-title">联系方式</h6>
                <address class="contact-info text-left">
                  <div class="unit unit-horizontal unit-spacing-md align-items-center">
                    <div class="unit-left">
                      <span class="novi-icon icon icon-xs icon-dusty-gray fa fa-envelope-o"></span>
                    </div>
                    <div class="unit-body">
                      <a class="link-white" href="mailto:731128239@qq.com">731128239@qq.com</a>
                    </div>
                  </div>
                  <div class="unit unit-horizontal unit-spacing-md">
                    <div class="unit-left">
                      <span class="novi-icon icon icon-xs icon-dusty-gray material-icons-place"></span>
                    </div>
                    <div class="unit-body">
                      <a class="link-white d-inline" href="#">安徽省合肥市蜀山区潜山路180号蔚蓝商务港城市广场C座1501室</a>
                    </div>
                  </div>
                </address>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 分隔线 -->
    <div class="container">
      <hr class="hr bg-abbey-04">
    </div>
    
    <!-- 版权信息 -->
    <div class="section-35">
      <div class="container text-center">
        <div class="row row-fix flex-md-row-reverse justify-content-md-between align-items-md-center row-15">
          <div class="col-md-6 text-md-right">
            <!-- 社交媒体链接区域 -->
          </div>
          <div class="col-md-6 offset-top-15 offset-sm-top-0 text-md-left">
            <p class="rights text-white">
              <span>&copy; </span>
              <span class="copyright-year">{{ currentYear }}</span>
              <span> 合肥联静数字科技有限公司</span>
              <a class="link-white-v2" href="https://beian.miit.gov.cn/" target="_blank">皖ICP备2022006545号-2</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'Footer',
  setup() {
    // 获取当前年份
    const currentYear = computed(() => {
      return new Date().getFullYear()
    })
    
    return {
      currentYear
    }
  }
}
</script>

<style scoped>
.page-foot {
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.bg-cape-cod {
  background-color: #404040;
}

.context-dark {
  color: #fff;
}

.section-40 {
  padding: 40px 0;
}

.section-35 {
  padding: 35px 0;
}

.section-md-75 {
  padding: 75px 0;
}

.footer-title {
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 20px;
}

.contact-info {
  font-style: normal;
}

.contact-info .unit {
  margin-bottom: 10px;
}

.contact-info .unit-left {
  margin-right: 10px;
}

.contact-info a {
  color: #fff;
  transition: color 0.3s ease;
}

.contact-info a:hover {
  color: #e03c31;
}

.link-white {
  color: #fff;
}

.link-white:hover {
  color: #e03c31;
}

.link-white-v2 {
  color: #aaa;
  transition: color 0.3s ease;
}

.link-white-v2:hover {
  color: #e03c31;
}

.text-dusty-gray {
  color: #999;
  margin-top: 10px;
}

.rights {
  font-size: 14px;
}

.hr {
  border: none;
  height: 1px;
  background-color: #555;
  margin: 0;
}

/* 响应式调整 */
@media (max-width: 991px) {
  .section-40 {
    padding: 30px 0;
  }
  
  .section-md-75 {
    padding: 50px 0;
  }
  
  .footer-title {
    margin-top: 20px;
  }
}

@media (max-width: 767px) {
  .section-40 {
    padding: 20px 0;
  }
  
  .section-35 {
    padding: 20px 0;
  }
  
  .contact-info {
    font-size: 13px;
  }
  
  .rights {
    font-size: 12px;
  }
}
</style>
